import { observer, inject } from 'mobx-react';
import * as React from 'react';
import { IAppStore } from 'stores/AllStores';
import { Modal } from 'components/content';
import { CreateLeadForm } from '.';
import { CreateLeadModalStatus } from 'common/interfaces/provider';

// Styles
const s = require('./CreateLeadModal.css');

// Props
interface ICreateLeadModalProps {
    store?: IAppStore;
}

// Component
@inject('store')
@observer
export class CreateLeadModal extends React.Component<ICreateLeadModalProps, {}> {
    constructor(props: ICreateLeadModalProps) {
        super(props);
    }

    public render() {
        // Destructure
        const { leads } = this.props.store;

        // Render
        return (
            <Modal
                onModalClose={this.closeModal}
                show={leads.modalStatus !== CreateLeadModalStatus.Closed}
                title="Create new lead"
            >
                <CreateLeadForm />
            </Modal>
        );
    }

    private closeModal = () => {
        this.props.store.leads.modalStatus = CreateLeadModalStatus.Closed;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/createlead/CreateLeadModal.tsx